import { Loader } from "@design-system/shadcn";
import React from "react";

interface DataTableLoadingOverlayProps {
  isLoading: boolean;
  children: React.ReactNode;
}

function DataTableLoadingOverlay({
  isLoading,
  children,
}: DataTableLoadingOverlayProps) {
  return (
    <div className="relative" aria-busy={isLoading} aria-live="polite">
      {isLoading && (
        <div className="absolute inset-0 z-10 flex items-center justify-center">
          <Loader size={32} />
        </div>
      )}
      <div className={isLoading ? "pointer-events-none opacity-50" : undefined}>
        {children}
      </div>
    </div>
  );
}

export { DataTableLoadingOverlay };
